export default function TestimonialsSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const changes = [
    {
      icon: 'ri-train-line',
      text: '通勤時間が片道1時間半から30分に短縮され、家族との時間が増えた',
      image:
        'https://public.readdy.ai/ai/img_res/303686659d34a96bc57312a20b368f7c.jpg',
      alt: '家族との時間が増えた',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      text: '毎月の家賃負担がほぼゼロになり、年間240万円の余裕が生まれた',
      image:
        'https://readdy.ai/api/search-image?query=Joyful%20illustration%20of%20Japanese%20man%20happily%20reviewing%20his%20bank%20savings%20account%20on%20laptop%20or%20smartphone%20showing%20significant%20balance%20increase%20of%202.4%20million%20yen%20annual%20savings%2C%20sitting%20in%20comfortable%20modern%20home%20office%20with%20relieved%20and%20satisfied%20expression%2C%20bright%20cheerful%20atmosphere%20with%20warm%20lighting%2C%20minimalist%20contemporary%20style%20with%20harmonious%20color%20palette%20of%20soft%20beige%20cream%20light%20gray%20and%20warm%20neutral%20tones&width=800&height=500&seq=savings-increase-happiness-001&orientation=landscape',
      alt: '年間240万円の余裕',
    },
    {
      icon: 'ri-flight-takeoff-line',
      text: '気兼ねなく家族旅行に行くことができるようになった',
      image:
        'https://readdy.ai/api/search-image?query=Vibrant%20illustration%20of%20happy%20Japanese%20family%20of%20four%20enjoying%20tropical%20beach%20vacation%20together%2C%20parents%20and%20two%20children%20laughing%20and%20playing%20by%20crystal%20clear%20ocean%20water%20under%20bright%20sunny%20sky%2C%20joyful%20carefree%20atmosphere%20showing%20financial%20freedom%20and%20quality%20family%20time%2C%20warm%20golden%20hour%20lighting%20with%20vivid%20yet%20harmonious%20color%20palette%20featuring%20sandy%20beige%20ocean%20blue%20and%20natural%20earth%20tones%2C%20contemporary%20illustration%20style&width=800&height=500&seq=family-vacation-beach-001&orientation=landscape',
      alt: '気兼ねなく家族旅行',
    },
    {
      icon: 'ri-wallet-3-line',
      text: '自由に使えるお金が増えた',
      image:
        'https://readdy.ai/api/search-image?query=Uplifting%20illustration%20of%20Japanese%20couple%20happily%20shopping%20and%20enjoying%20leisure%20activities%20in%20modern%20Tokyo%20shopping%20district%2C%20carrying%20shopping%20bags%20with%20big%20smiles%20showing%20financial%20freedom%20and%20disposable%20income%20lifestyle%2C%20bright%20cheerful%20urban%20scene%20with%20warm%20sunlight%2C%20contemporary%20minimalist%20style%20with%20clean%20aesthetic%20featuring%20warm%20neutral%20palette%20of%20soft%20cream%20beige%20light%20gray%20and%20gentle%20earth%20tones&width=800&height=500&seq=free-spending-lifestyle-001&orientation=landscape',
      alt: '自由に使えるお金が増えた',
    },
    {
      icon: 'ri-book-open-line',
      text: '子供の塾代を気にすることがなくなった',
      image:
        'https://readdy.ai/api/search-image?query=Heartwarming%20illustration%20of%20Japanese%20child%20studying%20enthusiastically%20at%20cram%20school%20desk%20with%20textbooks%20and%20notebooks%2C%20focused%20and%20motivated%20expression%20with%20parents%20watching%20proudly%20from%20doorway%20with%20relaxed%20smiles%20showing%20no%20financial%20stress%2C%20bright%20well-lit%20study%20room%20with%20encouraging%20warm%20atmosphere%2C%20contemporary%20minimalist%20illustration%20style%20with%20harmonious%20palette%20of%20soft%20cream%20beige%20warm%20white%20and%20gentle%20neutral%20tones&width=800&height=500&seq=child-study-relaxed-001&orientation=landscape',
      alt: '子供の塾代を気にしない',
    },
  ];

  return (
    <section className="py-8 pb-8 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            私が家賃ゼロ太郎くんを使って得られた変化は？
          </h2>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-xl p-8 md:p-12 border border-gray-200 mb-16">
          <div className="space-y-10 max-w-4xl mx-auto">
            {changes.map((item, index) => (
              <div
                key={index}
                className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-6 items-center bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm`}
              >
                <div className="w-full md:w-1/2 flex-shrink-0 h-48 md:h-[260px]">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 px-6 py-6 md:py-0">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-amber-50 rounded-full">
                      <i className={`${item.icon} text-2xl text-amber-600`}></i>
                    </div>
                    <p className="text-lg md:text-xl text-gray-800 leading-relaxed font-medium">
                      {item.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-br from-teal-50 to-cyan-50 rounded-xl shadow-lg p-8 md:p-10 border-2 border-teal-200">
          <div className="space-y-6 text-center">
            <p className="text-2xl md:text-3xl font-bold text-teal-600 mb-6">
              正直魅力的だと感じませんか？
            </p>
            <p className="text-base md:text-xl text-gray-800 leading-relaxed">
              私が20万円を追加で稼ごうと思ったら、<br className="hidden md:block" />
              別の仕事をしないと稼げないです。<br className="hidden md:block" />
              でも、私がしたことは会社を辞めることでもなく、<br className="hidden md:block" />
              新しい仕事をすることでもなく、<br className="hidden md:block" />
              <br className="hidden md:block" />
              <strong className="text-teal-700">
                【家賃ゼロ太郎くん】を利用しただけでした。
              </strong>
            </p>
            <p className="text-lg md:text-2xl font-bold text-gray-900 pt-4">
              ではその<span className="text-teal-600">【家賃ゼロ太郎くん】</span>とは<br className="hidden md:block" />
              どういうものなのか知りたくはありませんか？
            </p>
          </div>
        </div>


      </div>
    </section>
  );
}
